import axios from 'axios';

const instance = axios.create({
  baseURL: '/api', // 后端服务地址
  timeout: 300000,
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 这里可以添加请求头等
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);

export default instance;
